export enum AccountType {
  STAFF = 'staff',
  FREE = 'free',
  STANDARD = 'standard',
  CUSTOM = 'custom',
  AGENCY = 'agency'
}
